export default "__VITE_ASSET__PVK_Nc8t__"